angular = require('angular')
_ = require('lodash')

app = angular.module('workflow.app')

app.directive 'shiftSelectGroup', () ->
  restrict: 'A'
  controller: ($element) ->
    indexWhenShiftNotHeld = null
    valueWhenShiftNotHeld = null
    previouslySelected = []
    controllers = []

    shiftHeld = false
    $element.on 'mousedown',  (e) ->
      shiftHeld = e.shiftKey
      # return true because otherwise if you're not holding the shift key clicking things won't work
      return true

    register = (controller) ->
      controllers.push(controller)
      controller.$viewChangeListeners.push (value) ->
        onViewChange(controller, value)

    unregister = (controller) ->
      _.pull(controllers, controller)

    inProgress = false

    onViewChange = (controller, value) ->
      if inProgress
        return
      inProgress = true

      index = _.indexOf(controllers, controller)
      indexWhenShiftNotHeld = if not shiftHeld then index else indexWhenShiftNotHeld
      valueWhenShiftNotHeld = if not shiftHeld then controller.$viewValue else valueWhenShiftNotHeld

      start = if valueWhenShiftNotHeld then Math.min(index, indexWhenShiftNotHeld) else 0
      end = Math.max(index, indexWhenShiftNotHeld) + 1
      toSelect = if shiftHeld then _.range(start, end) else []
      toUnselect = if shiftHeld then _.difference(previouslySelected, toSelect) else []

      _.forEach toSelect, (i) ->
        controllers[i].$setViewValue(true)
        controllers[i].$render()

      _.forEach toUnselect, (i) ->
        controllers[i].$setViewValue(false)
        controllers[i].$render()

      previouslySelected = toSelect
      inProgress = false

    return {
      register: register
      unregister: unregister
    }


app.directive 'shiftSelect', () ->
  restrict: 'A',
  require: ['ngModel', '?^shiftSelectGroup'],
  link: (scope, element, attrs, controllers) ->
    [ngModelController, shiftSelectGroup] = controllers

    if !shiftSelectGroup
      return

    shiftSelectGroup.register(ngModelController)

    scope.$on '$destroy', () ->
      shiftSelectGroup.unregister(ngModelController)
